import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Shield } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_cf802d02-7a21-497a-89b7-2bcd31caeb90/artifacts/1chviqu2_Screenshot%202026-06-21%20at%2019.30.33-Photoroom.png';

export const Footer = () => (
  <footer className="bg-[#0B0D0C] text-white" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-center sm:text-left" data-testid="footer-sitemap">
        {/* Brand */}
        <div className="lg:col-span-1 flex flex-col items-center lg:items-start text-center lg:text-left">
          <div className="mb-5">
            <img
              src={LOGO_URL}
              alt="Portion Budget Meals"
              className="h-[88px] w-auto object-contain mx-auto lg:mx-0"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed">
            Персонализирани хранителни планове съобразени с твоите калории и бюджет.
          </p>
          <div className="flex items-center justify-center lg:justify-start gap-2 mt-4 text-xs text-neutral-500">
            <Shield className="w-3.5 h-3.5" />
            <span>Медицински подход. Без скрити такси.</span>
          </div>
        </div>

        {/* Platform */}
        <div>
          <h4 className="text-xs font-semibold text-neutral-400 mb-4 uppercase tracking-widest">Платформа</h4>
          <ul className="space-y-3">
            {[
              { to: '/calculator', label: 'Калкулатор' },
              { to: '/my-plan', label: 'Моят план' },
              { to: '/wallet', label: 'Абонамент' },
              { to: '/pricing', label: 'Ценообразуване' },
            ].map(l => (
              <li key={l.to}><Link to={l.to} className="text-sm text-neutral-400 hover:text-white transition-colors duration-150">{l.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Info */}
        <div>
          <h4 className="text-xs font-semibold text-neutral-400 mb-4 uppercase tracking-widest">Информация</h4>
          <ul className="space-y-3">
            {[
              { to: '/faq', label: 'Въпроси и отговори' },
              { to: '/about', label: 'За нас' },
              { to: '/contact', label: 'Контакти' },
              { to: '/disclaimer', label: 'Отказ от отговорност' },
            ].map(l => (
              <li key={l.to}><Link to={l.to} className="text-sm text-neutral-400 hover:text-white transition-colors duration-150">{l.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-xs font-semibold text-neutral-400 mb-4 uppercase tracking-widest">Правни</h4>
          <ul className="space-y-3">
            {[
              { to: '/terms', label: 'Общи условия' },
              { to: '/privacy', label: 'Политика за поверителност' },
              { to: '/disclaimer', label: 'Медицински отказ' },
            ].map(l => (
              <li key={l.to}><Link to={l.to} className="text-sm text-neutral-400 hover:text-white transition-colors duration-150">{l.label}</Link></li>
            ))}
          </ul>
          <div className="mt-6">
            <a href="mailto:info@portion.bg" className="flex items-center justify-center sm:justify-start gap-2 text-sm text-neutral-400 hover:text-white transition-colors duration-150">
              <Mail className="w-4 h-4" /> info@portion.bg
            </a>
          </div>
        </div>
      </div>

      <Separator className="my-8 bg-white/10" />

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
        <p>&copy; {new Date().getFullYear()} portion.bg. Всички права запазени.</p>
        <p className="text-center">Информацията е с образователна цел и не замества медицинска консултация.</p>
      </div>
    </div>
  </footer>
);
